import { useBreakPoints } from 'core';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { SegmentedControl } from 'ui';

const EarnLayout = () => {
  const { isSmallScreen } = useBreakPoints();
  const navigate = useNavigate();

  const isOnline = useMatch('/rewards/online/*');
  const tabValue = isOnline ? 'online' : 'dining';

  const showTabs = isSmallScreen;

  return (
    <>
      {showTabs && (
        <SegmentedControl
          size="sm"
          fullWidth
          value={tabValue}
          data={[
            {
              label: 'Dining',
              value: 'dining',
            },
            { label: 'Online', value: 'online' },
          ]}
          onChange={(value) => navigate(`/rewards/${value}`)}
          variant="light"
        />
      )}

      <Outlet />
    </>
  );
};

export default EarnLayout;
